module.exports = __webpack_public_path__ + "static/media/osquery-text-logo-2018-05-30.6639d4bd.png";